import MealRegistrationIcon from '@material-ui/icons/ViewList';

import MealRegistrationChangedHistoryList from './mealRegistrationChangedHistoryList';

export default {
  list: MealRegistrationChangedHistoryList,
  icon: MealRegistrationIcon,
};
